export default __webpack_public_path__ + "static/media/40.fb03602d.gif";